import { useCallback, useState } from "react"
import { MainNavProps } from "../navigation/main/MainParamList"
import { ScreenCloseModal } from "../../components/ScreenModal"
import { StyleSheet, TextInput, View } from "react-native"
import { Str_ChangeFail, Str_ChangeSuc, Str_Complete, Str_LabelName, Str_UpdateLabelName } from "../../language/string_res"
import { color_333333, color_999999, color_BEBEBE, color_main, ColorGrey, white } from "../../assets/style/colors"
import { ButtonView } from "../../components/ButtonView"
import { hideLoading, showLoading } from "../../components/Loading"
import * as ImSdk from "../../../imsdk/api";
import { showToast } from "../../components/Toast"
import globalEventBus from "../../utils/EventBus"

export const UpdateLabelModal = ({ navigation, route }: MainNavProps<'UpdateLabelModal'>) => {
    const label = route.params.label
    const [labelName, setLabelName] = useState(label)
    const onUpdateLabel = useCallback((newLabel: string) => {
        setTimeout(() => {
            showLoading()
            ImSdk.getInstance().UpdateLabel(label, newLabel).then((r) => {
                hideLoading()
                if (!r.error) {
                    showToast(Str_ChangeSuc)
                    globalEventBus.emit("UpdateLabel", { oldLabel: label, newLabel: newLabel })
                    navigation.goBack()
                } else {
                    showToast(r.error || Str_ChangeFail)
                }
            })
        }, 500);
    }, [label])
    return (<ScreenCloseModal title={Str_UpdateLabelName} >
        <TextInput
            autoCapitalize="none"
            autoFocus
            style={styles.inputContainer}
            placeholder={Str_LabelName}
            placeholderTextColor={color_BEBEBE}
            value={labelName}
            maxLength={16}
            onChangeText={setLabelName}
            blurOnSubmit={false}
        />
        <ButtonView
            style={[styles.updateComplete, { backgroundColor: labelName.length > 0 ? color_main : ColorGrey, }]}
            onPress={() => {
                onUpdateLabel(labelName)
            }}
            textStyle={[styles.updateTextComplete, { color: labelName.length > 0 ? white : color_999999, }]}
            text={Str_Complete} />

    </ScreenCloseModal>)
}


const styles = StyleSheet.create({
    inputContainer: {
        height: 44,
        width: '90%',
        fontSize: 16,
        paddingHorizontal: 12,
        marginTop: 20,
        color: color_333333,
        backgroundColor: ColorGrey,
        borderRadius: 10,
    },
    updateComplete: {
        marginTop: 40,
        height: 50,
        width: '50%',
        backgroundColor: ColorGrey,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 10,
    },
    updateTextComplete: {
        color: color_999999,
        fontSize: 16,
        fontWeight: 'bold',
        fontFamily: '',
    },
});